import { takeLeading, put, call, select } from "redux-saga/effects";
import { TResult } from "../../../../sg-core";
import {
    IRequestFetchObservation,
    createSuccessFetchObservationAction,
    createFailureFetchObservationAction,
    requestObservation
} from "../actions/observationActions";

import IObservation from "../../interfaces/IObservation";
import { IObservationService, getObservationService } from "../../services/observationService";
import { IUnparsedContext } from "../../interfaces/IHavainnotContext";
import { createUpdateAppContextAction } from "../actions/contextActions";
import { selectApiService } from "../../auth/store/authSelectors";
import { havainnot } from "../../../endpoints";

const makeFetchObservationSaga = (observationService: IObservationService) =>
    function* saga(action: IRequestFetchObservation) {
        const { observationGuid } = action.payload
        try {
            const { apiService, anonymousSession } = yield select(selectApiService)

            const obsService = getObservationService(apiService, havainnot, anonymousSession)
            const result: TResult<{ observation: IObservation, context: IUnparsedContext }> = yield call(obsService.getObservation, observationGuid);

            if (result.isSuccess) {
                yield put(createSuccessFetchObservationAction(result.value.observation));
                yield put(createUpdateAppContextAction(result.value.context));
            } else {
                yield put(createFailureFetchObservationAction(result.isFailure ? result.error : new Error()));
            }
        } catch (e) {
            yield put(createFailureFetchObservationAction(e as Error));
        }
    };

export default function create(observationService: IObservationService) {
    return takeLeading(
        requestObservation,
        makeFetchObservationSaga(observationService),
    );
}
